module.exports = __webpack_public_path__ + "static/media/17.042d7252.jpeg";